module.exports = __webpack_public_path__ + "img/marginalia-ecology-care.5285884a.png";